module.exports = __webpack_public_path__ + "static/img/loading.7f63184.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/loading/loading.gif
// module id = Id9t
// module chunks = 0